export const updatePermissions = (permissions) => 
    ({
        type    : "UPDATE_PERMISSIONS",
        payload : permissions
    })